import React from 'react';

import './SectionTitle.scss';

function SectionTitle({
  title, pill, useHtmlMarkup, viewAllLinkUrl, viewAllLinkTitle, children, id = '', motto,
}) {
  return (
    <div className="mn_sectionTitle">
      { motto && <div className="mn_titleMotto">{motto}</div> }
      { pill && <span className="mn_titlePill">{pill}</span> }
      {useHtmlMarkup
        ? <h2 id={id} data-test="sectTitle-heading" dangerouslySetInnerHTML={{ __html: title }} />
        : <h2 id={id} data-test="sectTitle-heading">{title}</h2>
      }

      { viewAllLinkUrl && <a className="mn_viewAllLink" href={viewAllLinkUrl}>{viewAllLinkTitle}</a>}

      {children}
    </div>
  );
}

SectionTitle.defaultProps = {
  viewAllLinkTitle: 'View all',
};

export default SectionTitle;
